/* unplugin-vue-components disabled */import { render } from "./Login.vue?vue&type=template&id=18521ba8"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import "./Login.vue?vue&type=style&index=0&id=18521ba8&lang=scss"
script.render = render

export default script